import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';


import SingleSelectDroupdown from './project-components/SingleSelectDroupdown';
import SelectDropDowns from '../DemoTabs/SelectDropDowns';
import SelectSearchDroupDown from '../../components/DemoTabs/SelectSearchDroupDown';
import SingleDateWithoutArrow from '../../components/Date-range-picker/SingleDateWithoutArrow';
import MemberProjectProfile from './project-components/MemberProjectProfile';



import PropTypes from 'prop-types';
import {
    Button,
    IconButton,
    Typography,
    Box,
    Modal,
    TextField,
    Tabs,
    Tab,
    InputLabel,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '600px',
    width: '90%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};



// start Tab Sec 
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: '24px 0 0' }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function splitTabs(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


// End Tab Sec 


const Reason = ({ open, onClose, }) => {
    // tabs 
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    // tabs 

    // <check Box 
    const [options, setOptions] = useState({
        billAble: true,
    });
    const toggleOption = (key) => {
        setOptions((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };
    // <check Box 
    // Project Seclect Single 
    const [selectedProject, setSelectedProject] = useState(null);
    // Project Seclect Single 


    // start Time Select
    const [selectStartTime, setselectStartTime] = useState('');
    const StartTimeData = [
        { name: '7:30 am' },
        { name: '8:00 am' },
        { name: '8:30 am' },
        { name: '9:00 am' },
        { name: '9:30 am' },
        { name: '10:00 am' },
    ];
    // End Time Select

    // start Second Time Select
    const [selectEndTime, setselectEndTime] = useState('');
    const EndTimeData = [
        { name: '7:30 am' },
        { name: '8:00 am' },
        { name: '8:30 am' },
        { name: '9:00 am' },
        { name: '9:30 am' },
        { name: '10:00 am' },
    ];
    // End Second Time Select


    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm">
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center"
                    sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>
                    <Typography variant="h6" fontSize={'22px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily: 'Manrope' }}>Reason</Typography>

                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>
                    <Box sx={{ margin: '0 auto 24px' }}>
                        <MemberProjectProfile />
                    </Box>
                    <Box sx={{ margin: '24px auto 0' }}>
                        <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily:'Manrope' }}>Reason*</InputLabel>
                        <TextField fullWidth multiline rows={3} placeholder="Assigned an incorrect task to the project. " variant="outlined"
                            sx={{
                                marginTop: '0px', fontFamily:'Manrope', '& .MuiOutlinedInput-root': {
                                    fontSize: '14px', color: '#64748B', fontFamily:'Manrope', fontSize:'14px',
                                    '& fieldset': { borderColor: '#D0D5DD',  fontFamily:'Manrope', fontSize:'14px'},
                                }, '& .MuiInputBase-input': { padding: '0px 0px', fontFamily:'Manrope', fontSize:'14px'},
                            }} />
                    </Box>
                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                    <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#595959" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily:'Manrope' }}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="primary" className='text-capitalize' sx={{ backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily:'Manrope' }}>
                        Save
                    </Button>
                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};

export default Reason;
